var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-placeholder fill-height d-flex flex-column justify-content-center align-items-center"},[_c(_vm.component,{tag:"component",attrs:{"config":_vm.config}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }